<template>
  <div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="类型" prop="type">
        <el-select
          v-model.number="queryParams.platForm"
          placeholder="请选择类型"
          size="small"
          @keyup.enter.native="handleQuery"
        >
          <el-option
            v-for="(item, index) in types"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <div ref="chartContainer" style="width: 100%; height: 500px;" />

    <div style="margin-top: 30px;" />
    <template>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="排名"
          width="180"
        >
          <template v-slot:default="props">
            {{ props.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="礼包类型"
          width="180"
        />
        <el-table-column
          prop="count"
          label="付费次数"
        />
        <el-table-column
          prop="price"
          label="付费金额"
        />
        <el-table-column
          prop="user"
          label="付费人数"
        />
      </el-table>
    </template>
  </div>
</template>

<script>
import { getGoodsAnalyzeData } from '@/api/statistics/user_remain'
import echarts from 'echarts'

export default {
  name: 'Goods',
  data() {
    return {
      tableData: [],
      loading: false,
      types: [
        { label: '付费金额', value: 1 },
        { label: '付费次数', value: 2 }
      ],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        platForm: 1
      },
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    getTables() {
      getGoodsAnalyzeData(this.queryParams).then(res => {
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        this.tableData = res.data.total
        const dateObj = {}
        const priceObj = {}
        const countObj = {}
        const titleMap = res.data.map
        this.option.xAxis.data = []
        this.option.legend.data = []
        this.option.series = []
        res.data.data.forEach(item => {
          dateObj[item.date] = item.date
          if (priceObj[item.gid] === undefined) {
            priceObj[item.gid] = []
            priceObj[item.gid].push(item.price)
          } else {
            priceObj[item.gid].push(item.price)
          }

          if (countObj[item.gid] === undefined) {
            countObj[item.gid] = []
            countObj[item.gid].push(item.count)
          } else {
            countObj[item.gid].push(item.count)
          }
        })
        for (const i in dateObj) {
          this.option.xAxis.data.push(dateObj[i])
        }
        let loopData = priceObj
        if (this.queryParams.platForm === 2) {
          loopData = countObj
        }

        for (const i in loopData) {
          if (loopData[i].length === 0) {
            continue
          }
          this.option.legend.data.push(titleMap[i])
          this.option.series.push({
            name: titleMap[i],
            data: loopData[i],
            type: 'line',
            axisLabel: {
              formatter: '${value}' // 使用默认的数值格式
            },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '${c}' // 显示数值
            }
          })
        }

        this.chart.setOption(this.option, true)
      })
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          notMerge: true
        },
        legend: {
          data: [],
          orient: 'horizontal', // 图例水平显示
          bottom: 0, // 图例在图表的底部
          left: 'center', // 图例居中对齐
          itemGap: 20, // 图例项之间的间距
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: 100,
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var tooltipHtml = ''
            params.forEach(function(item) {
              // 判断数值是否为 0
              if (item.value !== 0) {
                tooltipHtml += item.marker + ' ' + item.seriesName + ': ' + item.value + '<br>'
              }
            })
            return tooltipHtml
          }
        },
        series: []
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>

</style>
